import { Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({ selector: 'richtext-editor', templateUrl: './richtext-editor.component.html',changeDetection:ChangeDetectionStrategy.OnPush})
export class RichTextEditorComponent implements OnInit{

  @Input('widget') widget: any;

  constructor(private sanitizer: DomSanitizer) {}

  transform(content) {
    return this.sanitizer.bypassSecurityTrustHtml(content);
  }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/richtext-editor/richtext-editor.component.ts